/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/pdn'>.
 * ссылка из куки-баннера
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import PersonalDataConsent from '@routes/StaticPages/LegalPages/PersonalDataConsent';

export const Route = createFileRoute('/pdn')({
  component: () => (
    <CacheDataRoute component={PersonalDataConsent} path='/pdn' />
  )
});
